
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
}
.container-wrapper{
  position:relative;
  width:100%;
  padding-top:0;
  padding-top:var(--top-padding, 0);
  padding-bottom:0;
  padding-bottom:var(--bottom-padding, 0);
  padding-left:0;
  padding-left:var(--x-padding, 0);
  padding-right:0;
  padding-right:var(--x-padding, 0);
  margin-top:0;
  margin-top:var(--top-margin, 0);
  margin-bottom:0;
  margin-bottom:var(--bottom-margin, 0);
  --container-max-content-width:1840px;
}
.container-wrapper.position-unset{
    position:unset;
  }
.container{
  width:100%;
  display:flex;
  flex-direction:column;
  gap:var(--sic-container-space-between-elements);
  margin-right:auto;
  margin-left:auto;
  max-width:calc(var(--container-max-content-width) + 2 * var(--x-padding));
  position:relative;
}
.container.position-unset{
    position:unset;
  }
@media print{
  :host([print-top-padding='none']) .container-wrapper{
    padding-top:0;
  }
  :host([print-bottom-padding='none']) .container-wrapper{
    padding-bottom:0;
  }
}
.wide{
  --container-max-content-width:1840px;
}
.medium{
  --container-max-content-width:1312px;
}
.narrow{
  --container-max-content-width:860px;
}
.full{
  max-width:100%;
  --x-padding:0;
}
.justify-end{
  justify-content:flex-end;
}
`;